import { q } from 'groqd'

import { campaign } from './helperTypes'

export const campaignQuery = q('*')
  .filter('_type == "campaign" && name.current == $campaign')
  .grab(campaign)
  .slice(0)
  .nullable()
